import { z } from "zod";

const featuredTicketAutomationReceivedRule = z.object({
  id: z.string(),
  name: z.string(),
});

const returnTicketAutomationReceivedRule = z.object({
  id: z.string(),
  name: z.string(),
});

const examTicketAutomationReceivedRule = z.object({
  id: z.string(),
  name: z.string(),
});

const consultationTicketAutomationReceivedRule = z.object({
  id: z.string(),
  name: z.string(),
});

export const allowedActionSchema = z.object({
  id: z.string().optional(),
  newSchedule: z.boolean(),
  confirm: z.boolean(),
  cancel: z.boolean(),
  checkIn: z.boolean(),
  reschedule: z.boolean(),
  featuredTicketAutomationReceivedRule:
    featuredTicketAutomationReceivedRule.nullish(),
  returnTicketAutomationReceivedRule:
    returnTicketAutomationReceivedRule.nullish(),
  examTicketAutomationReceivedRule: examTicketAutomationReceivedRule.nullish(),
  consultationTicketAutomationReceivedRule:
    consultationTicketAutomationReceivedRule.nullish(),
});

export type TAllowedActionForm = z.infer<typeof allowedActionSchema>;
